import React from 'react';
import Icon from './index';
var customCache = new Set();
export default function createFromIconfont(scriptUrl) {
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    Iconfont.displayName = 'Iconfont';
    var type = props.type;
    var content;

    if (type) {
      content = React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    return React.createElement(Icon, props, content);
  };

  return Iconfont;
}